import utils from '../utils.js';
import imageUtils from '../imageUtils.js';
import { CONST } from '../../constant';
import { getFriends } from '../../api/communityMember.js';

const Commin = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    Vue.prototype.$utils = utils;
    Vue.prototype.$imageUtils = imageUtils;
    Vue.prototype.$commin = window.$commin;
    Vue.prototype.$user = window.$commin.user;
    Vue.prototype.$T = window.$commin.t;
    Vue.prototype.$I = window.$I;
    Vue.prototype.$C = window.$C;

    // We call Vue.mixin() here to inject functionality into all components.
    Vue.mixin({
      // Anything added to a mixin will be injected into all components.
      // In this case, the mounted() method runs when the component is added to the DOM.
      computed: {
        isGuest: function() {
          return !!window.$G;
        },
        w: function() {
          return this.$store.state.tools.windowWidth;
        },
        h: function() {
          return this.$store.state.tools.windowHeight;
        },
        y: function() {
          return this.$store.state.tools.windowScrollY;
        },
        devicePixelRatio: function() {
          return window.devicePixelRatio || 1;
        },
        minSize: function() {
          return this.w < this.h ? this.w : this.h;
        },
        ua: function() {
          return new UAParser().getResult();
        },
        cMap() {
          return this.$store.state.community.communityMap;
        },
        curCid() {
          return this.selectedCommunity.id;
        },
        curCmid() {
          return this.cidToCmid(this.cid);
        },
        curCmCover() {
          return this.cidToCmCover(this.curCid);
        },
        isSp: function() {
          return this.ua.os.name == 'iOS' || this.ua.os.name == 'Android';
        },
        isAndroid: function() {
          return this.ua.os.name == 'Android';
        },
        isOpeningDialog() {
          return (
            this.$store.state.viewer.viewer ||
            this.$store.state.file.upload ||
            this.$store.state.calendar.dialog.detail ||
            this.$store.state.calendar.dialog.edit
          );
        },
        displaySize: function() {
          return this.w >= 1280 ? 5 : this.w >= 1024 ? 4 : this.w >= 750 ? 3 : this.w >= 600 ? 2 : 1;
        },
        geMax: function() {
          return this.displaySize >= 5;
        },
        gePc: function() {
          return this.displaySize >= 4;
        },
        leTb: function() {
          return this.displaySize <= 3;
        },
        leTbS: function() {
          return this.displaySize <= 2;
        },
        leSp: function() {
          return this.displaySize <= 1;
        },
        classTerminal: function() {
          return (
            '' +
            (this.geMax ? ' ge-max' : '') +
            (this.gePc ? ' ge-pc' : '') +
            (this.leTb ? ' le-tb' : '') +
            (this.leTbS ? ' le-tbs' : '') +
            (this.leSp ? ' le-sp' : '')
          );
        },
        selectedCommunity() {
          return this.$store.state.community.selectedCommunity;
        },
        selectedCommunityName() {
          return this.selectedCommunity.name;
        },
        stateCommunities() {
          return this.$store.state.community.communities;
        },
        stateJoinedCommunities() {
          return this.$store.state.community.communities.slice(1);
        },
        cmidMap() {
          var ids = {};
          for (var c of this.stateJoinedCommunities) {
            ids[c.cmid] = 1;
          }
          return ids;
        },
        communityCount() {
          return this.stateCommunities.length;
        },
        isAllCommunitySelected() {
          return this.$store.state.community.selectedCommunity.id === 0;
        },
        userCover() {
          return this.$store.state.user.cover;
        },
        userLang() {
          return this.$store.state.user.lang;
        },
        userCountry() {
          return this.$store.state.user.country;
        },
        userTz() {
          return this.$store.state.user.timezone;
        },
        hasCommunity() {
          return this.stateCommunities.length > 1;
        },
        requireCommunityHelp() {
          return !this.isGuest && this.$store.state.tools.help && !this.hasCommunity;
        },
        requireAddMemberHelp() {
          if (this.isGuest || !this.$store.state.tools.help || !this.hasCommunity) {
            return false;
          }
          if (this.selectedCommunity.id == 0) {
            for (let c of this.stateCommunities) {
              if (c.id == 0) {
                continue;
              }
              if (!c.should_invite) {
                return false;
              }
            }
            return true;
          }
          return this.selectedCommunity.should_invite;
        },
        isUsFormat() {
          return this.$store.state.user.lang == 'en' && this.$store.state.user.country == 'us';
        },
        getMdFormat() {
          return this.isUsFormat ? $T('common.moment.us.mds') : $T('common.moment.mds');
        },
        unleadPost() {
          var tc = this.$store.state.post.todoCount;
          if (this.curCid) return tc[this.curCid];
          var c = 0;
          for (var k of Object.keys(tc)) c += tc[k];
          return c;
        },
        unleadTalk() {
          var ts = this.$store.state.talk.talks;
          var cid = this.curCid;
          var count = 0;
          var hasNew = false;
          for (var t of ts) {
            if (cid && t.cid != cid) continue;
            if (t.read_num == null) hasNew = true;
            count += t.last_num - (t.read_num ? t.read_num : 0);
          }
          return count >= 100 ? '99+' : count > 0 ? count : hasNew ? 'new' : null;
        },
      },
      methods: {
        getC(cid) {
          return this.cMap[cid];
        },
        getRouteCid() {
          return this.$route && this.$route.params && this.$route.params.id ? Number(this.$route.params.id) : 0;
        },
        clearSelfImgCaches: function() {
          for (let c of this.stateCommunities) {
            if (c.id == 0) {
              continue;
            }
            this.$commin.clientdb.delete('/cover/cm/' + c.cmid + '/');
          }
        },
        cidToCmid(cid) {
          var c = this.cMap[cid];
          return c ? c.cmid : 0;
        },
        cidToCmCover(cid) {
          return cid && this.cMap[cid] ? this.cMap[cid].cm_cover_path : this.userCover;
        },
        clearSelfImgCach: function(cid) {
          var c = this.getCommunity(cid);
          if (c) this.$commin.clientdb.delete('/cover/cm/' + c.cmid + '/');
        },
        isJoinedCommunity(communityId) {
          return !!this.$store.state.community.communityMap[communityId];
        },
        isSelf(cmid) {
          return this.cmidMap[cmid];
        },
        isUserSelf(communityId, cmid) {
          return (
            this.$store.state.community.communityMap[communityId] &&
            this.$store.state.community.communityMap[communityId].cmid == cmid
          );
        },
        isEditableCid(cid) {
          var c = this.cMap[cid];
          return !!c && (!c.pm || c.role == 1 || c.role == 2);
        },
        getCommunity(cid) {
          return utils.getCommunity(cid);
        },
        helpOff() {
          this.$store.commit('SET_HELP', false);
        },
        getCommunityName(communityId) {
          var c = this.$store.state.community.communityMap[communityId];
          if (c) {
            return c.name;
          }
          console.warn('failed to get communityId [' + communityId + ']');
          return '';
        },
        getCommunityCoverPath(communityId) {
          var c = this.$store.state.community.communityMap[communityId];
          if (c) {
            return c.cover_path;
          }
          console.warn('failed to get communityId [' + communityId + ']');
          return '';
        },
        isPublish(cid) {
          var c = this.getC(cid);
          return c && (c.pm || c.role == 1 || c.role == 2);
        },
        getInvitationLink(code, lang) {
          var url = window.location.protocol + '//' + window.location.host + '/invite/' + code;
          if (lang) url = url + '?l=' + lang;
          return url;
        },
        getMemberRoleText(val) {
          return CONST.community_member_roles[val];
        },
        getDatetimeByMemberTimezone(time) {
          return this.$moment(time).format(CONST.default_datetime_format);
        },
        isPast(unixTime) {
          return unixTime && this.$moment().isAfter(this.$moment.unix(unixTime));
        },
        utcToLocalDefault(strTime) {
          return strTime
            ? this.$moment(strTime.replace(' ', 'T') + '.000Z').format(CONST.default_datetime_format)
            : strTime;
        },
        utcToLocalMin(strTime) {
          return strTime ? this.$moment(strTime.replace(' ', 'T') + '.000Z').format(CONST.dt_format_min) : strTime;
        },
        utcToFormat(strTime) {
          return strTime ? this.formatMin(this.$moment(strTime.replace(' ', 'T') + '.000Z')) : strTime;
        },
        utcToDetail(strTime) {
          return strTime ? this.formatDetail(this.$moment(strTime.replace(' ', 'T') + '.000Z')) : strTime;
        },
        unix() {
          return this.$moment().unix();
        },
        moment() {
          return this.$moment().tz(this.$store.state.user.timezone);
        },
        unixToDefault(unixTime) {
          return this.$moment
            .unix(unixTime)
            .tz(this.$store.state.user.timezone)
            .format(CONST.default_datetime_format);
        },
        unixToMin(unixTime) {
          return this.$moment.unix(unixTime).format(CONST.dt_format_min);
        },
        unixToFormat(unixTime) {
          return this.formatMin(this.$moment.unix(unixTime));
        },
        unixToDetail(unixTime) {
          return this.formatDetail(this.$moment.unix(unixTime));
        },
        unixToDict(unixTime, dictKey) {
          return this.$moment.unix(unixTime).format($T(dictKey));
        },
        ymToDay1(ym) {
          const y = Math.floor(ym / 100);
          const m = ym % 100;
          const strM = m < 10 ? `0${m}` : String(m);
          return this.$moment.tz(`${y}-${strM}-01 00:00:00.000`, this.$store.state.user.timezone);
        },
        getCmFromFriends(friends, cmid, type, typeId, cb) {
          if (friends) {
            const f = friends[cmid];
            if (f) return f;
          }
          this.getCmFromFriendsAsync(friends, cmid, type, typeId, cb);
          return null;
        },
        getCmFromFriendsAsync(friends, cmid, type, typeId, cb) {
          const self = this;
          const key = `friend-${cmid}`;
          this.$commin.clientdb.getObject(key, friend => {
            if (friend) cb(friend.cm);

            if (friend && friend.t > time() - CONST.day) return;
            if (!type || !typeId) return;

            getFriends(type, typeId)
              .then(function(cms) {
                let hasCmid = false;
                const t = time();
                if (cms.length > 0) {
                  cms.forEach(cm => {
                    const key = `friend-${cm.id}`;
                    self.$commin.clientdb.putObject(key, { t: t, cm: cm });
                    if (friends) friends[cm.id] = cm;
                    if (cmid == cm.id) {
                      hasCmid = true;
                      cb(cm);
                    }
                  });
                }
                if (!hasCmid && !friend) {
                  const key = `friend-${cmid}`;
                  self.$commin.clientdb.putObject(key, { t: t, cm: null });
                }
              })
              .catch(function(e) {
                console.error('failed to get friends cms', e);
              });
          });
        },
        getCmName(cm, cid) {
          if (cm) return cm.guest ? $T('common.guest_user') : cm.nickname;
          var c = this.cMap[cid];
          return c && (c.pm || c.role == 1 || c.role == 2) ? $T('common.role.retired') : $T('common.role.member');
        },
        getCmCoverPath(cm, cid, type, typeId) {
          if (cm) {
            if (cm.is_indirect_friend && type && typeId)
              return `/cover/friend/${type}/${typeId}/${cm.id}/${cm.cover_changed_at || 0}`;
            return `/cover/cm/${cm.id}/${cm.cover_changed_at}`;
          }
          var c = this.cMap[cid];
          return c && (c.pm || c.role == 1 || c.role == 2)
            ? '/imgs/covers/member/unavailable.jpg'
            : '/imgs/covers/member/green.jpg';
        },
        getMemberKeyName(cms, gs, key, defStr) {
          if (!cms || !gs) return defStr;
          var id = Number(key.substring(1));
          if (key.startsWith('A')) {
            if (id == 1) return $T('common.community-all');
            if (id == 2) return $T('common.admin-all');
            if (id == 3) return $T('common.member-all');
            return defStr;
          }
          if (key.startsWith('m')) return cms[id] ? cms[id].nickname : defStr;
          return gs[id] ? gs[id].name : defStr;
        },
        formatDate(m) {
          let cur = this.$moment();
          if (m.format('YYYY') != cur.format('YYYY')) {
            if (this.isUsFormat) {
              return m.format($T('common.moment.us.ymd'));
            }
            return m.format($T('common.moment.ymd'));
          }
          if (this.isUsFormat) {
            return m.format($T('common.moment.us.md'));
          }
          return m.format($T('common.moment.md'));
        },
        formatMin(m) {
          let cur = this.$moment();
          if (m.format('YYYY') != cur.format('YYYY')) {
            if (this.isUsFormat) {
              return m.format($T('common.moment.us.ymd'));
            }
            return m.format($T('common.moment.ymd'));
          }
          if (m.format('MMDD') != cur.format('MMDD')) {
            if (this.isUsFormat) {
              return m.format($T('common.moment.us.md'));
            }
            return m.format($T('common.moment.md'));
          }
          return m.format($T('common.moment.hm'));
        },
        formatDetail(m) {
          if (this.isUsFormat) {
            return m.format($T('common.moment.us.full'));
          }
          return m.format($T('common.moment.full'));
        },
        diffDateFormat(m) {
          var c = this.$moment(this.$moment().format('YYYYMMDD'), 'YYYYMMDD');
          var dd = c.diff(m, 'days');
          if (dd == 0) return $T('common.today') + ' ' + m.format(this.getMdFormat);
          if (dd == 1) return $T('common.yesterday') + ' ' + m.format(this.getMdFormat);
          var dy = c.diff(m, 'years');
          var fmt;
          if (m.format('YYYY') == c.format('YYYY')) fmt = this.getMdFormat;
          else fmt = this.isUsFormat ? $T('common.moment.us.ymd') : $T('common.moment.ymd');
          return m.format(fmt);
        },
        diffDateFormatShort(m) {
          var c = this.$moment();
          var d = c.diff(m, 'minutes');
          if (d < 60) {
            if (d == 0) return $T('common.ago.ltmin');
            if (d == 1) return $T('common.ago.min', { t: d });
            return $T('common.ago.mins', { t: d });
          }
          var d = c.diff(m, 'hours');
          if (d <= 6) {
            if (d <= 1) return $T('common.ago.hour', { t: d });
            return $T('common.ago.hours', { t: d });
          }
          var nc = this.$moment(c.format('YYYYMMDD'), 'YYYYMMDD');
          var nm = this.$moment(m.format('YYYYMMDD'), 'YYYYMMDD');
          var d = nc.diff(nm, 'days');
          if (d <= 7) {
            if (d == 0) return m.format('H:mm');
            if (d == 1) return $T('common.yesterday');
            return $T('common.ago.days', { t: d });
          }
          var d = nc.diff(nm, 'years');
          if (d == 0) return nm.format(this.getMdFormat);
          return nm.format(this.userCountry == 'us' ? $T('common.moment.us.ymd') : $T('common.moment.ymd'));
        },
        shortMsg(msg, danger) {
          this.$store.commit('OPEN_SNACKBAR', { msg: msg, danger: !!danger });
        },
        alert(msg) {
          alert(msg);
        },
        resetShouldInviteMsg() {
          this.$store.commit('SET_SHOULD_INVITE', { id: this.selectedCommunity.id, value: false });
        },
        toAllName(key) {
          return CONST.allNames[key];
        },
        formatMsg(msg) {
          if (!msg) return '';
          return msg.replace(/[&'`"<>]|((https?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g, function(match) {
            return (
              CONST.htmlEscapes[match] ||
              '<a target="_blank" href="' + match + '">' + (match.length > 100 ? match.substring(100) : match) + '</a>'
            );
          });
        },
        postIcon(key) {
          return CONST.postIcons[key];
        },
        postIconG(key) {
          return CONST.postIconsG[key];
        },
        isComplete(item) {
          return (
            !item.is_member || item.answered || item.completed_at || (item.expire_at && this.isPast(item.expire_at))
          );
        },
        hasResult(item) {
          return item.result && typeof item.result === 'object' && Object.keys(item.result).length > 0;
        },
        saveYm(ym) {
          if (ym != 0 && (ym > CONST.tab_ym.limit.max || ym < CONST.tab_ym.limit.min)) {
            return console.warn(`invalid ym ${ym}`);
          }
          sessionStorage.setItem('ym', ym ? ym : 'n');
        },
        loadYm(defVal) {
          var ym = sessionStorage.getItem('ym');
          if (!ym) return defVal ? defVal : Number(this.$moment().format('YYYYMM'));
          if (ym == 'n') return ym;
          ym = Number(ym);
          if (ym > CONST.tab_ym.limit.max || ym < CONST.tab_ym.limit.min)
            return defVal ? defVal : Number(this.$moment().format('YYYYMM'));
          return ym;
        },
        getAllGroupsAndMembers(cid, cb, forceUpdate) {
          this.$utils.getAllGroupsAndMembers(cid, cb, forceUpdate);
        },
        errGetData() {
          this.shortMsg($T('common.err.getdata'), true);
        },
        errRegisterData() {
          this.shortMsg($T('common.failed.register'), true);
        },
        errEditData() {
          this.shortMsg($T('common.failed.edit'), true);
        },
        errDeleteData() {
          this.shortMsg($T('common.failed.delete'), true);
        },

        // convert api server validation errors message to form errors message
        _addFormErrorsApi(error) {
          this.formErrors = [];
          console.log(error);
          let errs = error.errors;
          self = this;
          jQuery.each(errs, function(i, val) {
            if (typeof i === 'string') {
              self.formErrors[i] = val[0];
            }
          });
        },
        // convert client validation errors message to form errors message
        _addFromErrorsClient() {
          let items = this.errors.items;
          if (items.length > 0) {
            this.formErrors = {};
            for (let i = 0; i < items.length; i++) {
              this.formErrors[items[i].field] = items[i].msg;
            }
          }
        },
      },
    });
  },
};

export default Commin;
